const defaultState = {
  verifyUser: {},
  error: null,
  fetching: false,
  fetched: false
};

const verifyUserReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'VERIFY_USER_FETCH_PENDING': {
      return {
        ...state, fetching: true
      };
    }
    case 'VERIFY_USER_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, verifyUser: action.payload
      };
    }
    case 'VERIFY_USER_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default verifyUserReducer;


// WEBPACK FOOTER //
// ./src/reducers/verifyUser.js